import AppService from '@/services/AppService.js'
const namespaced = true
const state = {
    code: '',
    updated_id: '',
    is_no_records: '',
    lists: {},
    total_count: '',
    count: 1,
    updated_tag: '',
    list: {},
    filter_list: {},
    filter_name: '',
    Updatelist: {},
    search_criteria: '',
    message: {},
    type: '',
    error: '',
    details: '',
    tag_list: [],
    log_details: '',
    sales_person_list: [],
    export: {},
    eway_bill_no: '',
    exempt_reason_list: [],
    status_code: '',
    status_message: '',
    status_type: '',
    credit_index_history:'',
    index_status:''

}
const mutations = {
    EWAY_NO(state, data) {
        state.eway_bill_no = data.eway_bill_no,
            state.message = data.status,
            state.type = data.type
    },
    SET_DATAS(state, lists) {
        state.error = ''
        state.lists = lists.credit_list
        state.total_count = lists.total_count
        state.count = lists.show
        state.search_criteria = lists.search
        state.is_no_records = lists.is_no_records
        state.filter_list = lists.filter_list
        state.filter_name = lists.filter_name
    },
    LIST_DATA(state, list) {
        state.list = list
        state.error = ''
    },
    UPDATED_TAG(state, updated_id) {
        state.updated_tag = updated_id
    },
    LIST_UPDATE_DATA(state, list) {
        state.Updatelist = list
        state.error = ''
    },
    EMAIL_RESULT(state, email_result) {
        state.email = email_result
        state.error = ''
    },
    LIST_ID(state, updated_id) {
        state.updated_id = updated_id
        state.error = ''
    },
    STATUS_CODE(state, code) {
        state.code = code
        state.error = ''
    },
    ERROR_STATUS(state, code) {
        state.error = code
    },
    CREDIT_LIST(state, data) {
        state.details = data
        state.tag_list = data.crdt_tags
        state.sales_person_list = data.sales_person_id
        state.exempt_reason_list = data.exempt_reason_list

    },

    TAG_LIST(state, data) {
        state.tag_list = data
    },
    LIST_LOG(state, data) {
        state.log_details = data
    },
    EXPORT_DATAS(state, lists) {
        state.export = lists
    },
    CANCEL_STATUS(state, data) {
        state.message = data
        state.error = ''
    },
    MESSAGE_DETAILS(state, data) {
        state.message = data.status
        state.type = data.type
    },
    SET_CODE(state, data) {
        state.status_code = data.code;
        state.status_message = data.status;
        state.status_type = data.type;
    },


}
const actions = {
    fetchLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {

        return AppService.credit.getCredits(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }else if (response.data.code != 404) {
                    commit("SET_CODE", response.data);
                    commit("SET_DATAS", response.data.data); // getting all the list in the api call
                  } else {
                    commit("SET_CODE", response.data);
                  }
                  return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchexportLists({
        commit,
        rootState
    }, {
        page,
        show,
        search,
        status,
        sort,
        label,
        custom
    }) {


        return AppService.credit.getCreditExport(page, show, search, status, sort, label, custom, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('EXPORT_DATAS', response.data.list) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    cancelcredit({
        commit,
        rootState
    }, data) {

        return AppService.credit.getCreditCancel(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                commit('STATUS_CODE', response.status)
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    createList({
        commit,
        rootState
    }, list) {

        return AppService.credit.postCredit(list, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    addTag({
        commit,
        rootState
    }, tag_name) {
        return AppService.general.postTag(tag_name, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }    else if(response.status == 201) {
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }else {
                    commit('TAG_LIST', response.data.data) // getting all the list in the api call
                    commit('UPDATED_TAG', response.data.updated_id)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                  
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateList({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.credit.postCreditUpdate(field, id, rootState.session.token)
            .then(response => {
                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else if (response.data.code== 201) {
                    commit('STATUS_CODE', response.status)
                    commit('CANCEL_STATUS', response.data.data)
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data)
                    commit('MESSAGE_DETAILS', response.data)
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },

    fetchList({
        commit,
        rootState
    }, id) {

        return AppService.credit.getCredit(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {

                    commit('LIST_UPDATE_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchCreditList({
        commit,
        rootState
    }, data) {

        return AppService.invoice.getCreditView(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('LIST_UPDATE_DATA', response.data)
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
            })
    },
    approvecredits({
        commit,
        rootState
    }, data) {

        return AppService.credit.getCreditsApprove(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                }
                commit('STATUS_CODE', response.status)
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
    fetchCreditDetails({
        commit,
        rootState
    }) {
        return AppService.credit.getCreditDetails(rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    rootState.general.filterdetails = response.data.data
                    commit('CREDIT_LIST', response.data.data)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    fetchviewList({
        commit,
        rootState
    }, id) {

        return AppService.credit.getCreditView(id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_DATA', response.data) // getting all the list in the api call

                }

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    updateRefund({
        commit,
        rootState
    }, {
        id,
        field
    }) {

        return AppService.credit.postCreditRefundUpdate(id, field, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data)
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deleteRefund({
        commit,
        rootState
    }, id) {

        return AppService.credit.postCreditRefundDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                    return response
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    deletecredit({
        commit,
        rootState
    }, data) {

        return AppService.credit.getCreditDelete(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
                return response
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
                return error
            })
    },
    filtercreateList({
        commit,
        rootState
    }, data) {

        return AppService.credit.postFiltercreateCredit(data, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterdelete({
        commit,
        rootState
    }, data) {

        return AppService.credit.postFilterdeleteCredit(data, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    filterupdateList({
        commit,
        rootState
    }, {
        id,
        data
    }) {

        return AppService.credit.postFilterudpateCredit(data, id, rootState.session.token)
            .then(response => {

                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('LIST_ID', response.data.data) // getting all the list in the api call
                    commit('STATUS_CODE', response.status) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    bulkdelete({
        commit,
        rootState
    }, id) {

        return AppService.credit.postCreditBulkDelete(id, rootState.session.token)
            .then(response => {
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit("SET_CODE", response.data);
                    commit('STATUS_CODE', response.status)
                    commit('LIST_LOG', response.data) // getting all the list in the api call
                }
            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500 // getting all the list in the api call
                }
            })
    },
    ewaybill({
        commit,
        rootState
    }, data) {

        return AppService.credit.addeway(data, rootState.session.token)
            .then(response => {

                commit('STATUS_CODE', response.status)
                if (response.status == 203) {
                    window.location.href = process.env.VUE_APP_LOGOUT_URL;
                } else {
                    commit('EWAY_NO', response.data)
                }
                return response

            })
            .catch(error => {
                if (!error.response) {
                    rootState.general.network_error = 500
                }
                return error
            })
    },
}

export default {
    namespaced,
    state,
    mutations,
    actions
}